<div class="modal-header d-flex flex-column">

    <div class="modal__title d-flex justify-content-between">
        <div class="modal__group">
            
            @if (icon) {
                <img class="modal__icon" [src]="icon">
            } @else if (svgIcon) {
                <mat-icon class="modal__icon" [svgIcon]="svgIcon"></mat-icon>
            }

            <div class="modal__content">
                <h2 
                    id="title"
                    class="modal__title-txt"
                    [ngClass]="{'modal__title-txt--small': subtitle && !sizeTitle}"
                    [style]="{'font-size': sizeTitle ?? ''}"
                >
                    {{title}}
                </h2>
    
                @if (subtitle) {
                    <p 
                        class="modal__subtitle"
                        [style]="{'font-size': sizeSubtitle ?? ''}"
                    >
                        {{subtitle}}
                    </p>
                }
            </div>
        </div>

        @if (!hideCloseBtn) {
            <button (click)="handleClose()">
                <mat-icon class="mat-icon--close">{{closeIcon}}</mat-icon>
            </button>
        }
    </div>

    @if (message) {
        <p id="message" class="modal__msg">{{message}}</p>
    }

</div> 